export interface ElementDwellSpan {
    elementKey: string;
    entranceTimestamp: number;
    exitTimestamp: number;
}

export interface ElementDwellSpansCache {
    active: Record<string, number>;
    completed: ElementDwellSpan[];
}

export type ElementDwellDurations = Record<string, number>;

export function createElementDwellSpansCache(): ElementDwellSpansCache {
    return { active: {}, completed: [] };
}

export function startElementDwellSpan(
    cache: ElementDwellSpansCache,
    elementKey: string,
    timestamp: number
): void {
    if (cache.active[elementKey] !== undefined) {
        return;
    }
    cache.active[elementKey] = timestamp;
}

export function endElementDwellSpan(
    cache: ElementDwellSpansCache,
    elementKey: string,
    timestamp: number
): void {
    const entranceTimestamp = cache.active[elementKey];
    if (entranceTimestamp === undefined) {
        return;
    }

    cache.completed.push({
        elementKey,
        entranceTimestamp,
        exitTimestamp: timestamp
    });

    delete cache.active[elementKey];
}

export function getElementDwellTimes(
    cache: ElementDwellSpansCache,
    intervalEndTimestamp: number
): ElementDwellDurations {
    const durations: ElementDwellDurations = {};

    cache.completed.forEach((span) => {
        const duration = Math.max(
            0,
            span.exitTimestamp - span.entranceTimestamp
        );
        durations[span.elementKey] =
            (durations[span.elementKey] || 0) + duration;
    });

    for (const elementKey in cache.active) {
        const entranceTimestamp = cache.active[elementKey];
        if (entranceTimestamp === undefined) {
            continue;
        }
        const duration = Math.max(0, intervalEndTimestamp - entranceTimestamp);
        durations[elementKey] = (durations[elementKey] || 0) + duration;
    }

    return durations;
}

export function rolloverActiveElementDwellSpans(
    cache: ElementDwellSpansCache,
    nextIntervalStartTimestamp: number
): void {
    cache.completed = [];
    for (const elementKey in cache.active) {
        cache.active[elementKey] = nextIntervalStartTimestamp;
    }
}

export function resetElementDwellSpansCache(
    cache: ElementDwellSpansCache
): void {
    cache.active = {};
    cache.completed = [];
}
